import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import * as classnames from 'classnames'
import './DisplayField.scss'

export default class DisplayField extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    fieldOnlyBoolean: PropTypes.bool
  }

  render() {
    const className = classnames('display-field', 'group', this.props.className)

    return (
      <div className={className}>
        {!this.props.fieldOnlyBoolean ? <span className="title">{this.props.title}</span> : null}
        <span className="value">{this.props.value ? this.props.value : '-'}</span>
      </div>
    )
  }
}
